import { JSONSchema7 } from "json-schema";

export const WelcomeMetadataSchema: JSONSchema7 = {
  description: "Welcome message shown to users after registering.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
